/**
 * @desc: Copied from https://git.perkbox.io/backend-services/deals/blob/master/src/Framework/ErrorCodes/ErrorCodes.php
 */
var PerksSettings;
(function (PerksSettings) {
    PerksSettings["SettingsAlreadyExistForTenant"] = "PBDEASettingAlreadyExistForTenant";
})(PerksSettings || (PerksSettings = {}));
export default PerksSettings;
